import { AppHeader } from '@/components/shared/AppHeader';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useGestaoImpostosContext } from '@/contexts';
import { GestaoImpostosProvider } from './GestaoImpostosProvider';
import { KpisPanel } from './components/kpis/KpisPanel';
import { SituacaoAtualTab } from './components/situacao-atual/SituacaoAtualTab';
import { HistoricoTab } from './components/historico/HistoricoTab';
import { SimulacaoTransicaoTab } from './components/simulacao-transicao/SimulacaoTransicaoTab';

export function GestaoImpostosPage() {
  return (
    <GestaoImpostosProvider>
      <GestaoImpostosPageInner />
    </GestaoImpostosProvider>
  );
}

function GestaoImpostosPageInner() {
  const { handleBuscar, handleLimparFiltrosGlobais, selecaoMensalValida, buscaAplicada } =
    useGestaoImpostosContext();

  return (
    <div className="min-h-screen bg-background">
      <AppHeader
        title="Gestão de Impostos"
        subtitle="Carga tributária e transição 2026-2033"
        onBuscar={handleBuscar}
        onLimparFiltros={handleLimparFiltrosGlobais}
      />

      <main className="w-full px-6 py-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-foreground text-balance mb-2">
            Gestão de Impostos
          </h2>
          <p className="text-muted-foreground text-pretty">
            Visão completa da carga tributária e simulação da transição para IBS/CBS até 2033
          </p>
        </div>

        {!selecaoMensalValida && !buscaAplicada ? (
          <div className="flex flex-col items-center justify-center py-24 text-center text-muted-foreground">
            <p className="text-base">Selecione uma empresa e um período (mês) no cabeçalho</p>
            <p className="mt-1 text-sm">e clique em Buscar para ver a carga tributária.</p>
          </div>
        ) : (
          <>
            <KpisPanel />

            <Tabs defaultValue="atual" className="space-y-6">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="atual">Situação Atual</TabsTrigger>
                <TabsTrigger value="historico">Histórico</TabsTrigger>
                <TabsTrigger value="transicao">Simulação Transição 2026-2033</TabsTrigger>
              </TabsList>

              <SituacaoAtualTab />
              <HistoricoTab />
              <SimulacaoTransicaoTab />
            </Tabs>
          </>
        )}
      </main>
    </div>
  );
}
